import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=a4eda01a&scoped=true&"
import script from "./SelectUnit.vue?vue&type=script&lang=js&"
export * from "./SelectUnit.vue?vue&type=script&lang=js&"
import style0 from "./SelectUnit.vue?vue&type=style&index=0&id=a4eda01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eda01a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
